// constants
import { DEAL_CATEGORY, TICKET_COUNT } from "@dineout-cart-client/constants";
import {
    IAggregatedItemsInfo,
    IResponseCartItem,
    IStoresInfo,
    IPartialPaymentWidget,
} from "@swiggy-private/checkout-core";
import { IDineoutCartResponse } from "@dineout-cart-client/interfaces";
import { IEventTicketDetails, IEventTicketItem } from "@dineout-cart-client/interfaces/Events";
import { ILocalCart, ILocalCartItem } from "@dineout-cart-client/interfaces/LocalCart";
import { isEmpty } from "@swiggy-private/js-utils";

export const isEventsCart = (cartState?: IDineoutCartResponse["data"] | null, localCart?: ILocalCart | null) => {
    return (
        cartState?.bill?.dealCategory === DEAL_CATEGORY.EVENTS ||
        localCart?.cartMetaData?.dealCategory === DEAL_CATEGORY.EVENTS
    );
};

export const isAnyItemUnavailable = (eventTicketDetails?: IEventTicketDetails): boolean => {
    return eventTicketDetails?.itemList?.some((ticket: IEventTicketItem) => ticket.outOfStock) || false;
};

export const areAllItemsUnavailable = (eventTicketDetails?: IEventTicketDetails): boolean => {
    return eventTicketDetails?.itemList?.every((ticket: IEventTicketItem) => ticket.outOfStock) || false;
};

export const getUnavailableItemsCount = (eventTicketDetails?: IEventTicketDetails): number => {
    return eventTicketDetails?.itemList?.filter((ticket: IEventTicketItem) => ticket.outOfStock).length || 0;
};

export const getTicketNameFromSavingsLine = (item: IResponseCartItem): string => {
    // TODO: remove this hack of fetching ticket name through savings line once backend starts sending a proper key
    return item.savingsLine?.split("x")[0].trim() || "";
};

export const getEventTicketDetails = (
    items?: IResponseCartItem[],
    localCartItems?: ILocalCartItem[],
    aggregatedItemsInfo?: IAggregatedItemsInfo,
): IEventTicketDetails | undefined => {
    if (isEmpty(items) || isEmpty(aggregatedItemsInfo)) {
        return;
    }

    const { dateDisplayTitle, timeDisplayTitle, ticketCountTitle } = aggregatedItemsInfo;
    const itemList: IEventTicketItem[] = items?.map((item) => {
        const itemVariantId = String(item.itemVariantId);
        const localCartItem = localCartItems?.find((localItem) => String(localItem.meta?.variantId) === itemVariantId);
        const itemName = getTicketNameFromSavingsLine(item);
        const itemPrice = item?.ticketAttributes?.totalEffectivePrice;
        const quantity = item.quantity;
        const outOfStock = item.outOfStock;
        const itemId = item.itemId;

        return {
            itemName,
            itemPrice,
            quantity: quantity || 0,
            outOfStock,
            itemId: itemId || "",
            itemVariantId,
            meta: localCartItem?.meta,
            serviceLine: localCartItem?.serviceLine,
            min: localCartItem?.min || TICKET_COUNT.MIN,
            max: localCartItem?.max || TICKET_COUNT.MAX,
        };
    });
    return {
        date: dateDisplayTitle,
        time: timeDisplayTitle,
        itemCountTitle: ticketCountTitle,
        itemList: itemList || [],
        notShowPrice: false,
        showAddButton: true,
        isDottedSeparator: true,
    };
};

export const getEventId = (cartState?: IDineoutCartResponse["data"] | null): string | undefined => {
    const itemId = cartState?.items?.[0]?.itemId;
    const eventId = itemId?.split("-")[1];
    if (isEmpty(eventId)) {
        return itemId;
    }
    return eventId;
};

export const getHeaderData = (storeInfo?: IStoresInfo, aggregatedItemsInfo?: IAggregatedItemsInfo) => {
    const { name, displayAreaName, cityName } = storeInfo || {};
    const eventName = aggregatedItemsInfo?.ticketTitle;
    return {
        title: eventName || "",
        subTitle: `${name}, ${displayAreaName}, ${cityName}`,
    };
};

export const getPartialPaymentWidget = (
    cartState?: IDineoutCartResponse["data"] | null,
): IPartialPaymentWidget | undefined => {
    return cartState?.partialPaymentWidget;
};
